import AddNoShowCtrl from '../AddNoShowCtrl';

import modalShiftFormUrl from './noShowForm.html';

export default {
  templateUrl: modalShiftFormUrl,
  controller: AddNoShowCtrl,
  controllerAs: 'ctrl',
  bindings: {
    data: '=',
    modal: '=',
    type: '@',
  },
};
